import { Button, Col, Row, Form, FormInstance, Input, message, Modal, Space, InputNumber, Select, Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../../server/Server";
import URL from "../../../../server/URL";

const AttributeRuleDetailEdit = (props: any) => {
    const formRef = useRef<FormInstance>(null);
    const [title, setTitle] = useState('新建规则属性[NULL]');
    const [viewMode, setViewMode] = useState(props.viewMode ?? 0);

    const [fillFormatValue, setFillFormatValue] = useState<any>(0);

    useEffect(() => {
        if (props.visible) {
            var title = '规则属性[NULL]';
            switch (props.viewMode) {
                case 0:
                    title = '规则属性[NULL]';
                    setData(null);
                    break;
                case 1:
                    title = '规则属性[' + (props.showLabel ?? '') + ']';
                    getData();
                    break;
                case 2:
                    title = '规则属性[' + (props.showLabel ?? '') + ']';
                    getData();
                    break;
                default:
                    setData(null);
                    break;
            }
            setViewMode(props.viewMode);
            setTitle(title)
        }
    }, [props.visible])

    const getData = () => {
        if (props.attributeRuleDetailID) {
            var params = {
                attributeRuleDetailID: props.attributeRuleDetailID
            };
            Server.Post(URL.AttributeRule.GetAttributeRuleDetail, params, false).then((response: any) => {
                if (response.isSuccess) {
                    setData(response);
                }
            })
        }
    }

    const setData = (record: any) => {
        formRef.current?.resetFields();
        if (props.attributeRuleDetailID) {
            formRef.current?.setFieldsValue({
                ...record,
                fillControl: { value: record.fillControlEnum, label: record.fillControl },
                fillFormat: { value: record.fillFormatEnum, label: record.fillFormat },
                partFillControl: { value: record.partFillControlEnum, label: record.partFillControl },
            });
            setFillFormatValue(record.fillFormatEnum);
        } else {
        }
    }

    const onEdit = () => {
        setViewMode(1)
    }

    const onOK = () => {
        formRef.current?.validateFields().then((values => {

            var request = {
                ...values,
                attributeRuleDetailID: props.attributeRuleDetailID,
                organizationID: props.organizationID,
                attributeRuleID: props.attributeRuleID,
                fillControlEnum: values.fillControl?.value,
                fillControl: values.fillControl?.label,
                fillFormatEnum: values.fillFormat?.value,
                fillFormat: values.fillFormat?.label,
                partFillControlEnum: values.partFillControl?.value,
                partFillControl: values.partFillControl?.label,
            };
            Server.Post(URL.AttributeRule.SaveAttributeRuleDetail, request).then((response: any) => {
                if (response.isSuccess) {
                    props.setVisibel(false);
                    props.reLoad();
                    message.success('保存成功');
                } else {
                    message.warning(response.returnMsg);
                }
            })
        })).catch((info: any) => {
            console.log(info);
        });
    }

    const onCancel = () => {
        props.setVisibel(false);
    }

    const getDefaultControl = () => {
        var control = <></>
        switch (fillFormatValue) {
            case 0:
                control = <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入长'} />;
                break;
            case 4:
                control = <Input.TextArea rows={3} disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入长'} />;
                break;
            default:
                control = <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入长'} />;
                break;
        }
        return control;
    }

    return <Modal
        maskClosable={false}
        title={title}
        width={900}
        visible={props.visible}
        footer={<>
            <Space>
                {viewMode == 2 ? <Button onClick={onEdit} type={'primary'}>编辑</Button> : <></>}
                {viewMode != 2 ? <Button onClick={onOK} type={'primary'}>保存</Button> : <></>}
                <Button onClick={onCancel}>关闭</Button>
            </Space>
        </>}
        onOk={onOK}
        onCancel={onCancel}>
        <Form ref={formRef}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}>
            <Row>
                <Col span={12}>
                    <Form.Item hidden style={{ marginBottom: '5px' }} name={'seqNO'} label={'序号'}
                        initialValue={''}>
                        <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入显示标签'} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'showLabel'} label={'显示标签'}
                        initialValue={''}
                        rules={[{ required: true, message: '请输入显示标签' }]}>
                        <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入显示标签'} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'orgLabel'} label={'原标签'}
                        initialValue={''}>
                        <Input disabled={true} style={{ width: '100%' }} placeholder={'请输入原标签'} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'fillControl'} label={'填写控制'}
                        initialValue={null}
                        rules={[{ required: true, message: '请选择填写控制' }]}>
                        <Select disabled={viewMode == 2}
                            style={{ width: '100%' }} placeholder={'请选择填写控制'}
                            labelInValue
                            defaultValue={0}
                            options={[
                                { value: 0, label: '禁用' },
                                { value: 1, label: '必录' },
                                { value: 2, label: '可选' },
                                { value: 3, label: '只读' },
                            ]} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'fillFormat'} label={'填写格式'}
                        initialValue={null}
                        rules={[{ required: true, message: '请选择填写格式' }]}>
                        <Select disabled={viewMode == 2}
                            style={{ width: '100%' }} placeholder={'请选择填写格式'}
                            labelInValue
                            defaultValue={0}
                            onChange={(e: any) => {
                                setFillFormatValue(e.value);
                            }}
                            options={[
                                { value: 0, label: '文本' },
                                { value: 1, label: '数字' },
                                { value: 2, label: '日期' },
                                { value: 3, label: '日期时间' },
                                { value: 4, label: '下拉选择' },
                                { value: 5, label: '基础数据' },
                            ]} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item hidden={fillFormatValue == 4 || fillFormatValue == 5} style={{ marginBottom: '5px' }} name={'defaultValue'} label={'默认值'}
                        initialValue={''}>
                        <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入默认值'} />
                    </Form.Item>
                    <Form.Item hidden={fillFormatValue != 4} style={{ marginBottom: '5px' }} name={'defaultValue'} label={'默认值'}
                        initialValue={''}>
                        <Input.TextArea rows={3} disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入默认值'} />
                    </Form.Item>
                    <Form.Item hidden={fillFormatValue != 5} style={{ marginBottom: '5px' }} name={'defaultValue'} label={'默认值'}
                        initialValue={''}>
                        <Select disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请选择默认值'} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item hidden={fillFormatValue == 5} style={{ marginBottom: '5px' }} name={'showValues'} label={'显示值'}
                        initialValue={''}>
                        <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输显示值'} />
                    </Form.Item>
                    <Form.Item hidden={fillFormatValue != 5} style={{ marginBottom: '5px' }} name={'showValues'} label={'显示值'}
                        initialValue={''}>
                        <Select disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请选择显示值'} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'partFillControl'} label={'产品填写控制'}
                        initialValue={null}
                        rules={[{ required: true, message: '请选择产品填写控制' }]}>
                        <Select disabled={viewMode == 2}
                            style={{ width: '100%' }} placeholder={'请选择产品填写控制'}
                            labelInValue
                            defaultValue={0}
                            options={[
                                { value: 0, label: '禁用' },
                                { value: 1, label: '必录' },
                                { value: 2, label: '可选' },
                                { value: 3, label: '只读' },
                            ]} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'是否激活'} name={'isActive'}
                        initialValue={true} valuePropName={'checked'}>
                        <Switch checked disabled={viewMode == 2} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'isCanZero'} label={'允许为0'}
                        initialValue={true} valuePropName={'checked'}>
                        <Switch checked disabled={viewMode == 2} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'isUnique'} label={'是否唯一'}
                        initialValue={true} valuePropName={'checked'}>
                        <Switch checked disabled={viewMode == 2} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }}
                        name={'isLinkage'} label={'是否联动'}
                        initialValue={true} valuePropName={'checked'}>
                        <Switch checked disabled={viewMode == 2} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    </Modal>
}
export default AttributeRuleDetailEdit;